export const environment = {
  production: false,
  apiUrl: 'https://apihomolog.teadit.ai/api',
  environmentLabel: 'HOMOLOG',
  version: '1.0.0',
  showQuestionSuggestions: false,
} as const;
